import { pressOsTab } from '@/tauri/dictation/api';

export const handleNextField = (): void => {
  void pressOsTab();
};
